<template>
    <div
        v-if="popper_isVisible && suggestions.length !== 0"
        class="dropdown-menu show overflow-auto"
        v-bind:style="`max-height: ${10 * 1.5 + 2}rem`">
        <div
            v-for="(addr, index) in suggestions"
            v-bind:id="`${suggestionId}${index}`"
            v-bind:key="index"
            v-bind:class="rowClass(index)"
            v-bind:value="index"
            v-on:click="$emit('autofill', index)"
            v-on:mouseover="$emit('update:highlight-index', index)">
            <div class="px-2">
                {{ addressDisplay(addr) }}
            </div>
            <div class="fw-bold text-primary px-2">
                {{ entriesDisplay(addr) }}
            </div>
        </div>
    </div>
</template>

<script>
    import popperMixin from "Components/page/Navigation/popperMixin";

    export default {
        mixins: [popperMixin],
        props: {
            suggestions: { type: Array, required: false, default: new Array(0) },
            highlightIndex: { type: Number, required: false, default: -1 }
        },
        emits: ["autofill", "popper-opened", "popper-closed", "update:highlight-index"],
        data() {
            return {
                popper_popperPlacement: "bottom-start",
                suggestionId: "address-popper-"
            };
        },
        watch: {
            highlightIndex() {
                if (this.highlightIndex != -1) {
                    // Scroll into view if needed
                    const suggestion = document.getElementById(`${this.suggestionId}${this.highlightIndex}`);
                    if (suggestion.offsetTop < this.$el.scrollTop) {
                        this.$el.scrollTop = suggestion.offsetTop;
                    } else {
                        const offsetBottom = suggestion.offsetTop + suggestion.offsetHeight;
                        const scrollBottom = this.$el.scrollTop + this.$el.offsetHeight;
                        if (offsetBottom > scrollBottom) {
                            this.$el.scrollTop = offsetBottom - this.$el.offsetHeight;
                        }
                    }
                }
            }
        },
        methods: {
            addressDisplay(addr) {
                let second = "";
                if (addr.Secondary) {
                    second = " " + addr.Secondary;
                    if (addr.Entries > 1) {
                        second = second + "...";
                    }
                }
                return addr.Street + second + " " + addr.City + ", " + addr.State + " " + addr.ZipCode;
            },
            entriesDisplay(addr) {
                if (addr.Entries > 1) {
                    return "+ " + addr.Entries + " addresses >";
                }
                return "";
            },
            rowClass(index) {
                if (index === this.highlightIndex) {
                    return "address-highlight d-flex justify-content-between";
                } else {
                    return "d-flex justify-content-between";
                }
            }
        }
    };
</script>
<style lang="scss" scoped>
    .address-highlight {
        background-color: var(--bs-gray-200);
    }
</style>
